// extracted by mini-css-extract-plugin
module.exports = {"title":"Subtitle_title__IKLmf","subtitle":"Subtitle_subtitle__6_SsI","heading":"Subtitle_heading__3NB8R","subtitleContainer":"Subtitle_subtitleContainer__YaCx4"};